import React from 'react';
import { motion } from 'framer-motion';
const features = ['+300 pág.', '9 proyectos', 'Planos reales', 'Medidas exactas', 'Paso a paso', 'Materiales argentinos', 'Proveedores por región', 'Fórmula de precio', 'Sistema de ventas', 'Marca personal', 'Técnica Shou Sugi Ban', 'Fotografía de venta', 'Negocio desde cero'];
const muebles = ['Banqueta Japandi', 'Repisa Flotante', 'Mesa Ratona', 'Escritorio Minimalista', 'Rack para TV', 'Cama Plataforma', 'Marca Personal', 'Técnica Shou Sugi Ban', 'Sistema de Ventas', 'Primeros $3000 USD'];
export function ProductOverview() {
  return <section className="py-8 md:py-16 px-4 bg-[#2B2724] text-white" data-id="element-244">
      <div className="max-w-7xl mx-auto" data-id="element-245">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-8" data-id="element-246">
          <span className="inline-block bg-[#C2613A] px-3 py-1 md:px-4 md:py-1 rounded-full text-[10px] md:text-xs font-semibold mb-3 md:mb-4" data-id="element-247">
            SISTEMA N°1 EN ARGENTINA
          </span>
          <h2 className="text-2xl md:text-5xl font-bold mb-2 md:mb-4" data-id="element-248">
            Megapack Muebles Japandi
          </h2>
          <p className="text-sm md:text-lg text-white/80 mb-6 md:mb-8" data-id="element-249">
            Sistema completo · 6 Tomos + 5 Bonos · Principiante a Avanzado ·
            Todo resuelto.
          </p>

          <div className="flex flex-wrap justify-center gap-1.5 md:gap-2 mb-6 md:mb-8" data-id="element-250">
            {features.map((feature, index) => <motion.span key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.03
          }} className="bg-white/10 backdrop-blur-sm px-2 py-1 md:px-3 md:py-1.5 rounded-full text-[10px] md:text-xs border border-white/20" data-id="element-251">
                {feature}
              </motion.span>)}
          </div>

          <p className="text-xs md:text-sm text-white/70 mb-6 md:mb-8" data-id="element-252">
            Funciona desde hoy en tu casa, balcón, lavadero o cochera.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/5 backdrop-blur-sm rounded-lg p-3 md:p-8 border border-white/10" data-id="element-253">
          <h3 className="text-base md:text-2xl font-bold mb-3 md:mb-6 text-center" data-id="element-254">
            Muebles incluidos:
          </h3>
          <div className="grid grid-cols-3 md:grid-cols-5 gap-1.5 md:gap-3" data-id="element-255">
            {muebles.map((mueble, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className="bg-[#C2613A]/20 backdrop-blur-sm px-1.5 py-1.5 md:p-4 rounded-md md:rounded-lg text-center text-[10px] md:text-sm font-medium border border-[#C2613A]/30 flex items-center justify-center leading-tight" data-id="element-256">
                {mueble}
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}